import { NgModule } from "@angular/core";

import { LocalStorageService } from "./services/local-storage.service";
import { AuthService } from "./services/auth.service";
import { AuthzService } from "./services/authz.service";
import { DtaService } from "./services/dta.service";
import { ModuleWithProviders } from "@angular/compiler/src/core";
import { LoginGuard } from "./guards/login.guard";
import { Router } from "@angular/router";
import { RejectGuard } from "./guards/reject.guard";

interface CoreConfig {
  defaultRoute: string;
  useHttps: boolean;
  wsEndpoint: string;
  httpEndpoint: string;
}

// @dynamic
// <-- this is needed to avoid the following error
//  BUILD ERROR
//    Error encountered in metadata generated for exported symbol 'CoreModule':
//    Metadata collected contains an error that will be reported at runtime: Lambda not supported.
@NgModule()
export class CoreModule {

  static forRoot(config: CoreConfig): ModuleWithProviders {
    return {
      ngModule: CoreModule,
      providers: [
        AuthzService,
        LocalStorageService,
        { 
          provide: DtaService,
          useValue: new DtaService(config.wsEndpoint, config.httpEndpoint),
        },
        { 
          provide: AuthService,
          useFactory: (dtaService: DtaService, localStorageService: LocalStorageService) => 
            new AuthService(dtaService, localStorageService, config.useHttps),
          deps: [DtaService, LocalStorageService]
        },
        { 
          provide: LoginGuard,
          useFactory: (authService: AuthService, router: Router) => new LoginGuard(authService, router, config.defaultRoute),
          deps: [AuthService, Router]
        },
        { 
          provide: RejectGuard,
          useFactory: (authService: AuthService, router: Router) => new RejectGuard(authService, router, config.defaultRoute),
          deps: [AuthService, Router]
        }        
      ]
    }
  }

}
